import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { WATER_LAKE_TSS_VECTOR } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { red, yellow, green, blue } from '@material-ui/core/colors'

const RIVER_CLASS_COLORS = [blue[300], yellow[300], red[300]]

const id = 'WaterLakeTssVector'
const sourceLayer = 'test2_sm'
const authId = 'WaterLakeTss'
const datetimeId = 'WaterLakeTss'

const defaultPaint = {
  'fill-opacity': 1,
  'fill-color': [
    'interpolate',
    ['linear'],
    ['to-number', ['get', 'Name']],
    -2, 'red',
    0, RIVER_CLASS_COLORS[0],
    1500, RIVER_CLASS_COLORS[1],
    3000, RIVER_CLASS_COLORS[2]
  ],
  'fill-outline-color': 'rgba(0, 0, 0, 0)'
}

export class WaterLakeTssVector extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''
    const vectorSource = {
      type: 'vector',
      tiles: [WATER_LAKE_TSS_VECTOR({ idToken, timeIso })],
      tileSize: 512
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id={id} tileJsonSource={vectorSource} />
        <Layer
          type='fill'
          id={id}
          sourceId={id}
          sourceLayer={sourceLayer}
          // filter={['all', ['>', ['number', ['get', 'Name'], 0], -3]]}
          // paint={{
          //   'fill-opacity': 1,
          //   'fill-color': {
          //     property: ['number', ['get', 'Name'], 2500],
          //     type: 'exponential',
          //     stops: [
          //       [1700, 'brown'],
          //       [2500, 'bisque'],
          //       [3300, 'greenYellow'],
          //       [3700, 'green']
          //     ]
          //   }
          // }}
          // filter={['!=', 'Name', '-2']}
          filter={['>', ['to-number', ['get', 'Name']], 0]}
          paint={paint}
        />
      </div>
    )
  }
}

WaterLakeTssVector.defaultProps = {
  paint: defaultPaint
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        'WaterLakeTssVector',
        'WaterLakeTss'
      ),
      paint: getPaint(state, id),
      time: state.layer.times.WaterLakeTss || undefined,
      datetime: getDatetime(state, datetimeId) || ''
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps(), null)(WaterLakeTssVector)



// WEBPACK FOOTER //
// ./src/layers/WaterLakeTssVector.js